import React from "react";
import { useNavigate } from "react-router-dom";
import { ErrorBoundary } from ".";
import { CompanyContext } from "./../contexts/CompanyContext";
import ReactTooltip from "react-tooltip";
import { FaEllipsisH } from "react-icons/fa";

function CompanySelect() {
  const navigate = useNavigate();
  const { companies, selectedCompany, selectCompany } =
    React.useContext(CompanyContext);

  return (
    <ErrorBoundary>
      <div className="dropdown company-dropdown">
        <button
          className="dropdown-toggle p-0 company-dropdown-btn"
          data-bs-offset="45,-43"
          data-bs-toggle="dropdown"
          disabled={companies.length > 1 ? false : true}
        >
          <img src={selectedCompany.logo_url} alt="companies nav icon" />
          {companies.length > 1 ? (
            <span className="icon-divider">
              <FaEllipsisH />
            </span>
          ) : null}
        </button>
        <ul className="dropdown-menu" aria-labelledby="dropdownMenu2">
          {companies.map((c) => (
            <li key={c.id}>
              <button
                className="dropdown-item"
                type="button"
                onClick={() => {
                  selectCompany(c);
                  navigate(`companies/${c.slug}`);
                }}
                data-tip={c.name}
                data-for="companyDropdownTooltip"
              >
                <img
                  src={c.logo_url}
                  alt={c.name}
                />
              </button>
            </li>
          ))}
        </ul>
        <ReactTooltip
          id="companyDropdownTooltip"
          effect="solid"
          place="right"
          className="company-dropdown-tooltip"
          clickable={true}
        />
      </div>
    </ErrorBoundary>
  );
}

export default CompanySelect;
